"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {find, hasClass, removeClass, addClass, closest, on} from "@elements/dom-utils";

export function init () {
    onFind('.js-overlay-toggle', function (overlayToggle) {
        const overlayToggleHandler = evt => {
            let targetId = overlayToggle.getAttribute('data-overlay-toggle-target');
            let optionalClass = overlayToggle.getAttribute('data-overlay-toggle-class');
            let overlayItem = document.getElementById(targetId);

            if (hasClass('is-open', overlayItem)) {
                closeOverlay(overlayItem, optionalClass)
            } else {
                openOverlay(overlayItem, optionalClass)
            }
        };

        let mediaQuery = overlayToggle.getAttribute('data-overlay-toggle-media-query');

        if(!mediaQuery || matchMedia(mediaQuery).matches){
            on('click', overlayToggleHandler, overlayToggle);
        }

    });
}

export function openOverlay(overlay, optionalClass) {
    addClass('is-open', overlay);
    addClass('overlay-open', find('body'));

    // just optional if you need a optional class on a parent element
    if (find('.js-overlay-toggle__parent') && optionalClass){
        addClass(optionalClass, find('.js-overlay-toggle__parent'));
    }

}

export function closeOverlay(overlay, optionalClass) {
    removeClass('is-open', overlay);
    removeClass('overlay-open', find('body'));

    if (find('.js-overlay-toggle__parent') && optionalClass){
        removeClass(optionalClass, find('.js-overlay-toggle__parent'));
    }

}